<template>
  <div class="App-error bg-white">
    <div class="inner text-center">
      <div class="content">
        <div class="main">{{$t('error.main')}}</div>
        <div class="sub">{{$t('error.sub')}}</div>
        <div class="lead white-space-pre-wrap" v-html="$t('error.lead')"></div>
        <div class="btn-wrapper">
          <router-link class="btn btn-red" :to="{'name':'home.index'}">{{$t('btn.back_complete')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PageNotFound'
  }
</script>
